import { DEFAULT_FONT } from 'commons/styles/font';

export const Styled = {
  body: {
    paddingTop: 20,
    paddingBottom: 30,
    paddingHorizontal: 40,
  },
  pdf: {
    width: '90vw',
    height: '90vh',
  },
  logo: {
    width: '30px',
    height: '30px',
  },
  text: {
    fontSize: 11,
    lineHeight: 1.5,
    fontFamily: DEFAULT_FONT,
    fontWeight: 'normal',
  },
  textBold: {
    fontSize: 11,
    lineHeight: 1.5,
    fontFamily: DEFAULT_FONT,
    fontWeight: 'bold',
  },
  title: {
    margin: '10px 0',
    fontSize: 11,
    lineHeight: 1.5,
    fontWeight: 'bold',
    fontFamily: DEFAULT_FONT,
    textAlign: 'center',
  },
  textDate: {
    margin: '10px 0',
    fontSize: 11,
    lineHeight: 1.5,
    fontWeight: 'bold',
    fontFamily: DEFAULT_FONT,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },
  header: {
    borderBottom: '1px solid #000',
    padding: '5px 0',
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tableHeader: {
    backgroundColor: '#CCCCCC',
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10px',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
  },
  tableColumn: ({
    width,
    hasBorder = false,
    isBold = false,
  }: {
    width: string;
    hasBorder: boolean;
    isBold: boolean;
  }) => ({
    minHeight: '20px',
    flexBasis: width,
    fontSize: 11,
    border: hasBorder ? '1px solid #CCCCCC' : '',
    padding: '5px',
    fontWeight: isBold ? 'bold' : 'normal',
    fontFamily: DEFAULT_FONT,
  }),
  separator: (width: string, hasMargin = true) => ({
    width: width ?? '100%',
    backgroundColor: '#000',
    height: '1px',
    margin: hasMargin ? '5px 0 10px 0' : '',
  }),
  subHeader: {
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'column',
  },
  section: {
    marginBottom: 10,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  sectionLeft: {
    flexBasis: '50%',
  },
  sectionRight: {
    flexBasis: '50%',
    textAlign: 'left',
  },
  alignRight: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
  },
  alignDown: {
    display: 'flex',
    alignItems: 'flex-end',
    flexDirection: 'row',
  },
  flexWrap: {
    isplay: 'flex',
    flexDirection: 'row',
    gap: 30,
  },
  allListFigurants: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    margin: '10px 0',
  },
  listFigurants: {
    display: 'flex',
    flexDirection: 'column',
  },
};
